/*global twttr*/
// Forces tweets render before page ready.
// If an ad takes too long to load or a server request hangs tweets won't render.
// This way we make sure they will load when twitter widget has loaded. Check social-widgets.twig

(function () {
    'use strict';

    if (window.twttr) { // We don't always include Twitter widget library on MAPI.
        window.twttr.ready(renderTwitterEmbeds);
    }

    ////////////////////

    function renderTwitterEmbeds() {
        var postContentsEl = document.querySelector('.post-contents');

        if (postContentsEl) {
            // Force tweets rendering before the document is ready
            twttr.widgets.load(postContentsEl);
        }
    }
}) ();